import React from 'react';
import cx from 'classnames';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const UserInfoStat = ({
  data,
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style, ...props }, data.map((item, i) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.col, {
      [styles.hidden]: item.hidden
    }),
    key: i
  },
  /* @__PURE__ */ React.createElement("div", { className: styles.title }, item.title),
  /* @__PURE__ */ React.createElement("div", { className: styles.value }, /* @__PURE__ */ React.createElement(Icon, { ...item.icon }), " ", item.value)
)));
UserInfoStat.displayName = "UserInfoStat";

export { UserInfoStat };
//# sourceMappingURL=index.js.map
